/**
 * Alert queries: the key factory (everything under ['alerts']), a filtered
 * list (previous page kept while the next loads) and the bell's counts —
 * polled every minute, only for whoever may see alerts. TanStack Query
 * pauses the poll while the tab is hidden.
 */

import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useAuth } from '@/hooks';

import * as svc from '../services/alerts.service';

export const ALERT_POLL_MS = 60_000;

export const alertsKeys = {
  all: ['alerts'] as const,
  list: (params: svc.AlertListParams) => [...alertsKeys.all, 'list', params] as const,
  counts: () => [...alertsKeys.all, 'counts'] as const,
};

export const useAlerts = (params: svc.AlertListParams, enabled = true) =>
  useQuery({
    queryKey: alertsKeys.list(params),
    queryFn: () => svc.listAlerts(params),
    placeholderData: keepPreviousData,
    enabled,
  });

export function useAlertCounts() {
  const { hasPermission } = useAuth();
  return useQuery({
    queryKey: alertsKeys.counts(),
    queryFn: svc.getAlertCounts,
    refetchInterval: ALERT_POLL_MS,
    enabled: hasPermission('alerts.view'),
  });
}
